import Quill from 'quill-next';

const Block = Quill.import('blots/block') as any;

export class ListeningArticleEnBlock extends Block {
  static blotName = 'listening-article-en';
  static className = 'ql-l-article-en';
  static tagName = 'div';

  static create(value: any) {
    const domNode = super.create(value);

    // 给container传参，不直接消费
    domNode.dataset.timestart = value.startTime;
    domNode.dataset.timeend = value.endTime;
    domNode.dataset.order = value.order;

    return domNode;
  }

  showTrans() {
    this.domNode.dataset.showtrans = 'true';
  }

  hideTrans() {
    this.domNode.dataset.showtrans = '';
  }
}
